import React, { createContext, useCallback, useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { VIEW_MODES } from './BudgetFundCompareTab/budgetFundCompareHelpers.js';
import { getAllProgramsByBudgetId } from '../../services/programService.js';
import { useUser } from '../../contexts/userContext.js';

const dataVisualizationState = {
  currentTab: 0,
  sortByProperty: '',
};

const DataVisualizationContext = createContext(dataVisualizationState);

const DataVisualizationContextProvider = ({ children }) => {
  const [loadedBudgetId, setLoadedBudgetId] = useState(null);
  const [currentTab, setCurrentTab] = useState(0);
  const [sortByProperty, setSortByProperty] = useState('');
  const [programs, setPrograms] = useState([]);
  const { user } = useUser();
  const [selectedBudgetOrFundContext, setSelectedBudgetOrFundContext] =
    useState(VIEW_MODES.BUDGETS);
  const dataVizContainerRef = useRef(null); // we need this static main container in order reusable customDrilldown to work properly everywhere(Program cost, Cost type-both accordions) in data visualizations, concerning the tooltip positioning

  const fetchProgramsIfNeeded = useCallback(async (budgetId) => {
    if (budgetId === loadedBudgetId || !budgetId) return;
    const resp = await getAllProgramsByBudgetId(budgetId);
    setPrograms(resp.data);
    setLoadedBudgetId(budgetId);
  }, [loadedBudgetId]);

  const clearPrograms = () => {
    setPrograms([]);
    setLoadedBudgetId(null);
  };

  useEffect(() => {
    clearPrograms();
  },[user?.activeOrganization, user?.activeBudget, user?.activeCostCenters]);

  return (
    <DataVisualizationContext.Provider
      value={{
        currentTab,
        setCurrentTab,
        sortByProperty,
        setSortByProperty,
        clearPrograms,
        programs,
        fetchProgramsIfNeeded,
        selectedBudgetOrFundContext,
        setSelectedBudgetOrFundContext,
        dataVizContainerRef,
      }}
    >
      {children}
    </DataVisualizationContext.Provider>
  );
};

DataVisualizationContextProvider.propTypes = {
  children: PropTypes.node,
};

export default DataVisualizationContextProvider;
export { DataVisualizationContext };
